"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  value: "500+",
  label: "Flights Handled"
}, {
  value: "150k+",
  label: "Tons of Cargo"
}, {
  value: "24/7",
  label: "Operations Support"
}, {
  value: "15+",
  label: "Years of Excellence"
}];
function StatItem({
  stat,
  index
}: {
  stat: typeof statsData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <div data-section-id="125030" ref={ref} data-index={index} className={`flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="relative inline-flex items-center justify-center mb-4">
        {}
        <div className="absolute w-[120%] h-[120%] bg-primary/20 blur-[32px] rounded-full animate-pulse -z-10"></div>
        
        {}
        <span className="text-6xl sm:text-7xl lg:text-8xl font-bold text-primary tracking-tighter drop-shadow-2xl">
          {stat.value}
        </span>
      </div>
      
      {}
      <span className="font-mono text-sm sm:text-base text-foreground/80 uppercase tracking-widest">
        {stat.label}
      </span>
    </div>;
}
export default function GlobalPulseStats() {
  return <section id="operational-excellence-in-numbers" className="w-full bg-secondary text-foreground py-24 lg:py-32 relative overflow-hidden border-y border-primary/10">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: '4rem 4rem'
    }}></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {statsData.map((stat, index) => <StatItem key={index} stat={stat} index={index} />)}
        </div>
      </div>
    </section>;
}